import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_ACCETTATO_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolAccettatoKoState extends EntityState<IID_OL_ACCETTATO_KO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_ACCETTATO_KO })
@InterfaceDataStore(InterfaceName.ACCETTAZIONE_NEGATIVA)
export class IIDolAccettatoKoStore extends EntityStore<IIDolAccettatoKoState> {
  constructor() {
    super([]);
  }
}
